import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from '../../../components/Button';
import Loader from '../../../components/Loader';
import {
  BookingModuleSelectors,
  getOwnerBookingModules,
  saveOwnerBookingModules,
} from '../../../redux/reducers/bookingModuleSlice';
import { ButtonType } from '../../../utils/@globalTypes';
import BookingModuleCard from './BookingModuleCard';
import styles from './BookingModuleSettings.module.scss';

const BookingModuleSettings = () => {
  const dispatch = useDispatch();
  const modules = useSelector(BookingModuleSelectors.getModules);
  const isLoading = useSelector(BookingModuleSelectors.getIsLoading);
  const loadError = useSelector(BookingModuleSelectors.getLoadError);
  const isSaving = useSelector(BookingModuleSelectors.getIsSaving);
  const hasChanges = useSelector(BookingModuleSelectors.getHasChanges);
  const hasInvalidThemeColor = useSelector(
    BookingModuleSelectors.getHasInvalidThemeColor,
  );

  useEffect(() => {
    dispatch(getOwnerBookingModules());
  }, [dispatch]);

  return (
    <section className={styles.container}>
      <div className={styles.heading}>
        <div>
          <h2>Модуль бронирования</h2>
          <p>Ссылки, интеграция и общие настройки модулей ваших объектов.</p>
        </div>
        {!!modules?.length && (
          <Button
            title={
              <span className={styles.saveButtonLabel}>
                <span
                  className={isSaving ? styles.hiddenLabel : undefined}
                  aria-hidden={isSaving}
                >
                  Сохранить
                </span>
                <span
                  className={!isSaving ? styles.hiddenLabel : undefined}
                  aria-hidden={!isSaving}
                >
                  Сохраняем…
                </span>
              </span>
            }
            type={ButtonType.PRIMARY_SMALL}
            disabled={
              !hasChanges || hasInvalidThemeColor || isSaving || isLoading
            }
            onClick={() => dispatch(saveOwnerBookingModules())}
          />
        )}
      </div>

      {modules === null && isLoading && <Loader />}

      {modules === null && loadError === 'free_tariff' && (
        <div className={styles.notice} role="alert">
          <p>Для работы с Модулем бронирования нужен платный тариф.</p>
          <Link to="/prices">Посмотреть тарифы</Link>
        </div>
      )}

      {modules === null && loadError === 'request_failed' && (
        <div className={styles.notice} role="alert">
          <p>Не удалось загрузить модули бронирования.</p>
          <button
            type="button"
            onClick={() => dispatch(getOwnerBookingModules())}
          >
            Повторить
          </button>
        </div>
      )}

      {modules?.length === 0 && (
        <div className={styles.emptyState} role="status">
          <p>
            Создайте свой первый основной объект, чтобы работать с Модулем
            Бронирования
          </p>
          <Link to="/object-management">Создать основной объект</Link>
        </div>
      )}

      {!!modules?.length && (
        <div className={styles.moduleList}>
          {modules.map((module) => (
            <BookingModuleCard
              key={module.id}
              module={module}
              defaultExpanded={modules.length === 1}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default BookingModuleSettings;
